import React, { useEffect } from 'react';
import PageShell from '../common/PageShell.jsx';
import PageHero from '../common/PageHero.jsx';
import videoAbout from '../../assets/about.mp4';
import videoServices from '../../assets/core.mp4';
import videoFunding from '../../assets/funding.mp4';
import algofunding from '../../assets/algofunding.mp4';
import partner from '../../assets/partner.mp4';
import brokers from '../../assets/brokers.mp4';
import algoInvestment from '../../assets/algoInvestment.mp4';

const VideoGallery = () => {
  useEffect(() => {
    document.title = 'Video Gallery | Eco World Capital';
  }, []);

  const videos = [
    { id: 1, title: 'About Eco World Capital', desc: 'Discover how EWC combines market expertise, innovative technology, and a client-centric approach to be your trusted partner for financial growth.', videoSrc: videoAbout },
    { id: 2, title: 'Core Products & Services', desc: 'Explore our diverse range of offerings, from algorithmic trading solutions and portfolio management to global market technology and loan arrangements.', videoSrc: videoServices },
    { id: 3, title: 'Investing & Funding Solutions', desc: 'Discover clear, step-by-step guidance for all your financial needs. From algorithmic trading software and portfolio monitoring to customized business loans and private equity, we connect you with the right tools and partners.', videoSrc: videoFunding },
    { id: 4, title: 'Algorithmic Trading Software', desc: 'Learn how to automate your trading strategies using our algorithmic solutions for both Indian and global markets. We offer lease, rental, and outright purchase options to suit your budget and help reduce emotional decision-making.', videoSrc: algofunding },
    { id: 5, title: 'EWC Partnership Models', desc: 'Explore our performance-based partnership opportunities. Whether you are seeking a franchise, a strategic alliance, or an investment partnership, our shared-success models align our goals with yours.', videoSrc: partner },
    { id: 6, title: 'Our Trusted Broker Network', desc: 'EWC is proud to be associated with regulated, globally recognized financial market participants. Discover our network of partners, including Bonanza Portfolio, Alice Blue, Exness, and OctaFX.', videoSrc: brokers },
    { id: 7, title: 'Premium Algorithmic Investment Plans', desc: 'An overview of our high-tier algorithm trading plans for Indian and global markets. Learn about our Joint Venture Agreements (JVA), risk management strategies, and how you maintain full control of your trading funds.', videoSrc: algoInvestment },
  ];

  return (
    <PageShell>
      <div className="flex flex-col min-h-screen">
        <PageHero
          badge="Media & Insights"
          title="Video Gallery"
          subtitle="Explore our curated collection of corporate presentations, market insights, and strategic investment overviews."
        />

        <section className="pt-4 pb-24 px-6 md:px-12 max-w-7xl mx-auto flex-grow">
          <p className="text-sm text-brand-cream-muted text-center mb-8 font-medium">
            Tap play on any video below. Use the volume control in the player to enable audio.
          </p>
          <div className="grid md:grid-cols-2 gap-10">
            {videos.map((video, index) => (
              <article
                key={video.id}
                className="glass-card rounded-3xl overflow-hidden group flex flex-col hover:bg-brand-cream/20 hover:border-brand-gold-light/50 transition-all duration-300"
              >
                <div className="w-full aspect-video bg-black relative border-b border-brand-cream/20">
                  <video
                    className="absolute top-0 left-0 w-full h-full object-cover focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold"
                    src={video.videoSrc}
                    controls
                    playsInline
                    preload={index < 2 ? 'metadata' : 'none'}
                    aria-label={video.title}
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>

                <div className="p-8 relative overflow-hidden flex-grow shimmer-hover">
                  <div className="relative z-10">
                    <h3 className="text-2xl font-extrabold text-brand-gold mb-3 tracking-wide drop-shadow-sm">{video.title}</h3>
                    <p className="text-[15px] text-brand-cream-muted/90 leading-relaxed font-medium">{video.desc}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </PageShell>
  );
};

export default VideoGallery;
